import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    // 登录页
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/login.vue'),
    },
    {
      path: '/',
      redirect: '/home',
      component: () => import('@/views/home/home.vue'),
      meta: {
        keepAlive: true,
        flag: true,
      },
    },
    {
      //商品列表
      path: '/home',
      name: 'home',
      component: () => import('@/views/home/home.vue'),
      meta: {
        keepAlive: true,
        flag: true,
      },
    },

    {
      // 我的订单
      path: '/CommodityOrder',
      name: 'CommodityOrder',
      component: () => import('@/views/commodity-order/commodity-order.vue'),
    },
    {
      // 购物车
      path: '/shoppingCart',
      name: 'shoppingCart',
      component: () => import('@/views/shopping-cart/shopping-cart.vue'),
    },
    {
      // 我的收藏
      path: '/collection',
      name: 'Collection',
      component: () => import('@/views/collection/collection.vue'),
    },
    {
      // 我的足迹
      path: '/footprint',
      name: 'Footprint',
      component: () => import('@/views/footprint/footprint.vue'),
    },
    {
      //修改密码
      path: '/changepassword',
      name: 'Changepassword',
      component: () => import('@/views/changepassword/changepassword.vue'),
    },
    {
      //日志管理
      path: '/logmanagement',
      name: 'Logmanagement',
      component: () => import('@/views/logmanagement/logmanagement.vue'),
    },
    {
      //账号管理
      path: '/accountmanagement',
      name: 'Accountmanagement',
      component: () =>
        import('@/views/accountmanagement/accountmanagement.vue'),
    },
    {
      //新增账号
      path: '/newaccount',
      name: 'Newaccount',
      component: () => import('@/views/newaccount/newaccount.vue'),
    },
    {
      //组织机构
      path: '/organizationalstructure',
      name: 'Organizationalstructure',
      component: () =>
        import('@/views/organizationalstructure/organizationalstructure.vue'),
    },
    {
      // pos登录页
      path: '/poslogin',
      name: 'poslogin',
      component: () => import('@/views/login/pos-login.vue'),
    },
    {
      // 云平台登录页
      path: '/yunLogin',
      name: 'yunLogin',
      component: () => import('@/views/login/yun-login.vue'),
    },
    {
      // 素金页面
      path: '/plaingold',
      name: 'plaingold',
      component: () => import('@/views/plaingold/plaingold.vue'),
    },
    {
      path: '/analysis',
      name: 'Analysis',
      component: () => import('@/views/analysis/analysis.vue'),
    },
  ],
})
/**
 * 解决重复触发同一个路由报错问题
 */
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

export default router
